<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>退款列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">平台名称</label>
              <el-select
                class="jm-input280"
                v-model="searchData.project_id"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.project_list"
                  :label="item.name"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">退款时间</label>
              <el-date-picker
                class="jm-input280"
                v-model="searchData.refund_date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="box-content">
              <label class="form-tit">订单编号</label>
              <el-input
                v-model="searchData.order_no"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">退款方式</label>
              <el-select
                class="jm-input280"
                v-model="searchData.payment_method"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.refund_type"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">退款金额</label>
              <el-input
                placeholder="起始金额"
                class="jm-input135"
                v-model="searchData.total_amount_min">
              </el-input>
              <el-input
                placeholder="结束金额"
                class="jm-input135"
                v-model="searchData.total_amount_max">
              </el-input>
            </div>
            <div class="box-content">
              <label class="form-tit">退款账户</label>
              <el-input
                v-model="searchData.payment_account"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">审核状态</label>
              <el-select
                class="jm-input280"
                v-model="searchData.examine_step"
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in selectDict.examine_step"
                  :label="item.value"
                  :key="item.id"
                  :value="item.id"/>
              </el-select>
              <el-checkbox v-model="searchData.is_me">我处理</el-checkbox>
            </div>
            <div class="box-content">
              <label class="form-tit">学生编号</label>
              <el-input
                v-model="searchData.pub_userid"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">退款编号</label>
              <el-input
                v-model="searchData.id"
                class="jm-input280"/>
            </div>
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => { this.$store.commit('updateRefresh', true) }" :loading="btnLoading">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields" :loading="btnLoading">重置</el-button>
            <el-button
              class="jm-input-common3"
              type="success"
              @click="exportDetails" :loading="btnLoading">导出明细</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
          >
            <el-table-column
              slot="memo"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.memo" placement="left">
                  <span>{{ props.row.memo }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="examine_message"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
            >
              <template slot-scope="props">
                <el-tooltip popper-class="table-tooltip-area" effect="dark" :content="props.row.examine_message" placement="left">
                  <span>{{ props.row.examine_message }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="120"
              label="操作">
              <template slot-scope="scope" v-if="scope.row.project_id === 10">
                <router-link
                  target="_blank"
                  :to="{ name: 'gkryOrderDetail', params: { id:scope.row.order_id }}">
                  <el-button
                    type="success"
                    size="small">查看详情</el-button>
                </router-link>
                <el-button
                  type="success"
                  @click="openProcessDialog(scope.row)"
                  size="small">查看流程单</el-button>
                <el-button
                  type="primary"
                  v-show="checkRefund(scope.row, 0)"
                  @click="openRefundDialog(scope.row)"
                  size="small">退款审核</el-button>
                <el-button
                  v-show="checkRefund(scope.row, 1)"
                  type="primary"
                  @click="openRefundDateDialog(scope.row)"
                  size="small">设置退款日期</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
        <!--退款信息弹窗 start-->
        <el-dialog
          title="退款审核"
          :visible.sync="refundDialogLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="支付方式：">
                  <span>{{ refundForm.payment_method }}</span>
                </el-form-item>
                <el-form-item label="退款账号：">
                  <span>{{ refundForm.payment_account }}</span>
                </el-form-item>
                <el-form-item label="退款金额：">
                  <span>{{ refundForm.total_amount }}</span>
                </el-form-item>
                <el-form-item label="退款备注：">
                  <span>{{ refundForm.memo }}</span>
                </el-form-item>
                <el-form-item label="审核备注：">
                  <el-input
                    type="textarea"
                    :rows="4"
                    resize="none"
                    placeholder="请输入内容"
                    v-model="refundForm.examine_message">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogClose(1)">取 消</el-button>
            <el-button type="primary" @click="refundInfoSave" :loading="btnLoading">同 意</el-button>
            <el-button type="danger" @click="refundInfoRefuse" :loading="btnLoading">驳 回</el-button>
          </span>
        </el-dialog>
        <!--退款信息弹窗 end-->
        <!--退款日期弹窗 start-->
        <el-dialog
          title="退款日期设置"
          :visible="refundDateDialogLock"
          width="600px"
          :show-close="false">
          <el-form label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="支付方式：">
                  <span>{{ refundDateForm.payment_method }}</span>
                </el-form-item>
                <el-form-item label="退款账号：">
                  <span>{{ refundDateForm.payment_account }}</span>
                </el-form-item>
                <el-form-item label="退款金额：">
                  <span>{{ refundDateForm.total_amount }}</span>
                </el-form-item>
                <el-form-item label="退款备注：">
                  <span>{{ refundDateForm.memo }}</span>
                </el-form-item>
                <el-form-item label="退款日期：">
                  <el-date-picker
                    type="date"
                    v-model="refundDateForm.refund_date"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="dialogClose(2)">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="refundDateSave">修 改</el-button>
            <el-button type="danger" :loading="btnLoading" @click="refundDateRefuse">驳 回</el-button>
          </span>
        </el-dialog>
        <!--退款信息弹窗 end-->
        <!--流程单弹窗 start-->
        <el-dialog
          title="退款流程单"
          :visible.sync="processDialogLock"
          @cancel="processDialogCancel"
          width="795px"
        >
          <div style="max-height: 500px; overflow-y: auto">
            <div class="process-dialog-wrap" id="printProcess" ref="printContent">
              <div class="title-area">
                <h3>退款流程单</h3>
                <i>退款编号：{{ processForm.id }}</i>
              </div>
              <div class="process-dialog-area">
                <div class="content-area">
                  <span></span>
                  <span></span>
                </div>
                <div class="content-area">
                  <span>财务总监签字：</span>
                  <span></span>
                </div>
                <div class="content-area">
                  <span>退款发起人：</span>
                  <span>{{ processForm.pub_teacher }}</span>
                </div>
                <div class="content-area">
                  <span>申请时间：</span>
                  <span>{{ processForm.create_time }}</span>
                </div>
                <div class="content-area">
                  <span>姓名：</span>
                  <span>{{ processForm.pub_account }}</span>
                </div>
                <div class="content-area">
                  <span>学校：</span>
                  <span>{{ processForm.school_name }}</span>
                </div>
                <div class="content-area">
                  <span>退款方式：</span>
                  <span>{{ processForm.payment_method }}</span>
                </div>
                <div class="content-area">
                  <span>联系电话：</span>
                  <span>{{ processForm.pub_telphone }}</span>
                </div>
                <div class="content-area">
                  <span>退款金额：</span>
                  <span>{{ processForm.total_amount }}（元）</span>
                </div>
                <div class="content-area">
                  <span>退款账户：</span>
                  <span>{{ processForm.payment_account }}</span>
                </div>
                <div class="content-area large-size">
                  <span>备注：</span>
                  <span>{{ processForm.memo }}</span>
                </div>
              </div>
              <el-table class="tableList printTable" :data="processForm.log_list">
                <el-table-column
                  width="120px"
                  prop="examine_function"
                  label="审核人职能">
                </el-table-column>
                <el-table-column
                  width="120px"
                  prop="examine_name"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  width="120px"
                  prop="create_time"
                  label="审核时间">
                </el-table-column>
                <el-table-column
                  width="90px"
                  prop="examine_status_str"
                  label="审核结果">
                </el-table-column>
                <el-table-column
                  prop="examine_message"
                  label="审核备注">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <template slot="footer">
            <el-button
              size="small"
              type="primary"
              v-print="printObj">打印</el-button>
          </template>
        </el-dialog>
        <!--流程单弹窗 end-->
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      activeName: 'gkry', // 当前项目
      searchData: {
        project_id: '',
        payment_method: '',
        total_amount_min: '',
        total_amount_max: '',
        order_no: '',
        finance_status: '',
        pub_userid: '',
        id: '',
        is_me: false
      },
      getListurl: '/finance/refund/pagetable', // 表格数据源
      refundDialogLock: false, // 退款信息弹窗锁
      selectDict: {}, // 下拉框字典
      refundForm: {}, // 退款信息弹窗内容
      refundDateForm: {
        refund_date: ''
      }, // 退款日期弹窗表单
      refundDateDialogLock: false, // 退款日期弹窗锁
      processDialogLock: false, // 流程单弹窗锁
      processForm: {}, // 流程单变量
      printObj: {
        id: 'printProcess',
        popTitle: '昆仑系统-退款流程单'
      },
      btnLoading: false
    };
  },
  computed: {
  },
  methods: {
    // 获取页面数据
    getPageData() {
      this.btnLoading = false;
      this.$http
        ._post({
          url: '/finance/refund/searchDs'
        })
        .then((res) => {
          this.selectDict = res.data;
        });
    },
    // 重置搜索
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = null;
      });
      this.$store.commit('updateRefresh', true);
    },
    // 退款审核 + 设置退款日期 按钮展示
    checkRefund(row, type) {
      let key = Math.floor(Number(row.examine_status) / 2);
      switch (type) {
        case 0:
          // 退款审核
          if (key < row.examine_json_list.length - 1 && [1, row.examine_uid].indexOf(this.$store.getters.userInfo.userid) !== -1) {
            return true;
          }
          break;
        case 1:
          // 设置退款日期
          if (key === row.examine_json_list.length - 1 && [1, row.examine_uid].indexOf(this.$store.getters.userInfo.userid) !== -1) {
            return true;
          }
          break;
        default:
          break;
      }
      return false;
    },
    // 关闭弹窗
    dialogClose(check) {
      switch (check) {
        case 1:
          this.refundDialogLock = false;
          break;
        case 2:
          this.refundDateDialogLock = false;
          break;
        default:
          break;
      }
    },
    // 打开退款审核弹窗
    openRefundDialog(row) {
      this.refundDialogLock = true;
      this.refundForm = Object.assign({}, row, { examine_message: '' });
    },
    // 打开设置退款日期
    openRefundDateDialog(row) {
      if (!row.refund_date) {
        row.refund_date = '';
      }
      this.refundDateDialogLock = true;
      this.refundDateForm = Object.assign({}, row, { examine_message: '' });
    },
    // 导出明细
    exportDetails() {
      this.btnLoading = true;
      this.$http
        ._post({
          url: '/finance/refund/excelList',
          data: { searchData: this.searchData }
        })
        .then(({ data }) => {
          this.$http._download({
            filename: data,
            download: '退款明细.xlsx'
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款审核同意
    refundInfoSave() {
      this.btnLoading = true;
      this.refundForm.examine_status = Number(this.refundForm.examine_status) + 2;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundForm
        })
        .then(() => {
          this.$message.success('审核成功');
          this.refundDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款审核驳回
    refundInfoRefuse() {
      this.btnLoading = true;
      this.refundForm.examine_status = Number(this.refundForm.examine_status) + 1;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundForm
        })
        .then(() => {
          this.$message.success('已驳回');
          this.refundDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款日期保存
    refundDateSave() {
      this.btnLoading = true;
      this.refundDateForm.examine_status = Number(this.refundDateForm.examine_status) + 2;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundDateForm
        })
        .then((res) => {
          if (res.result === -1) {
            this.$message.error(res.msg);
          } else {
            this.$message.success('退款日期保存成功');
            this.refundDateDialogLock = false;
            this.$store.commit('updateRefresh', true);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 退款日期驳回
    refundDateRefuse() {
      this.btnLoading = true;
      this.refundDateForm.examine_status = Number(this.refundDateForm.examine_status) + 1;
      this.$http
        ._post({
          url: '/finance/refund/updateExamine',
          data: this.refundDateForm
        })
        .then(() => {
          this.$message.success('已驳回');
          this.refundDateDialogLock = false;
          this.$store.commit('updateRefresh', true);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 打开流程单弹窗
    openProcessDialog (row) {
      this.$http
        ._post({
          url: '/finance/refund/findAllPoint',
          data: { id: row.id }
        })
        .then((res) => {
          this.processForm = res.data;
          this.processDialogLock = true;
        });
    },
    // 关闭流程单弹窗
    processDialogCancel() {
      this.processDialogLock = false;
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  mounted() {
    this.getPageData();
  }
};
</script>
<style scoped lang="less">
  .tableList .el-button{
    padding: 0 13px;
  }
  .printTable{
    /deep/ .el-table__row td:last-of-type .cell {
      padding-right: 25px;
    }
  }
  .process-dialog-wrap .title-area{
    position: relative;
  }
  .process-dialog-wrap .title-area i{
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  .process-dialog-wrap{
    border: 1px solid #e8e8e8;
    padding-top: 10px;
  }
  .process-dialog-wrap .title-area{
    line-height: 40px;
    padding: 0 15px;
  }
  .process-dialog-wrap .process-dialog-area{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 10px 15px 15px;
  }
  .process-dialog-wrap .process-dialog-area .content-area{
    width: 50%;
    line-height: 25px;
    font-size: 14px;
  }
  .el-tooltip{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
</style>
